<template>
    <div class="attachment-wrap" :class="{ '-dragging': drag }">
        <div
            class="attachment"
            :class="{ '-avatar': type == 'avatar' }"
            :menuContent="attachmentMenu"
            @click="download"
        >
            <img
                class="attachment-image"
                :src="source"
                size="small"
                v-if="convertedAttachment.type == 'image'"
            />
            <img
                :src="require('@/assets/icons/default.svg')"
                class="attachment-file-icon"
                v-if="convertedAttachment.type != 'image' && type == 'avatar'"
            />
            <img
                :src="
                    require(`@/assets/icons/docsIcons/${convertedAttachment.type}.svg`)
                "
                class="attachment-file-icon"
                v-if="convertedAttachment.type != 'image' && type != 'avatar'"
            />
        </div>
        <div class="attachment-name" v-if="type != 'avatar'">
            {{ convertedAttachment.name }}
        </div>
    </div>
</template>
<script>
export default {
    props: {
        editing: {
            type: Boolean,
            default: false
        },
        attachment: [Object, String],
        index: Number,
        type: {
            type: String,
            default: 'Standard'
        },
        drag: Boolean
    },
    data() {
        return {
            selectedAttachment: {}
        }
    },
    computed: {
        convertedAttachment() {
            return typeof this.attachment == 'object'
                ? this.attachment
                : {
                      path: this.attachment,
                      type: this.$Utils.getFileType(this.attachment),
                      name: this.$Utils.getAttachmentName(this.attachment)
                  }
        },
        source() {
            return this.convertedAttachment.local
                ? this.convertedAttachment.path
                : this.$Utils.convertImageUrl(this.convertedAttachment.path)
        },
        attachmentType() {
            return this.$Utils.getFileType(this.attachment)
        },
        attachmentMenu() {
            const menu = [
                {
                    event: {
                        name: 'show',
                        id: this.attachment
                    },
                    display: this.$t('BUTTON_SHOW'),
                    materialIcon: 'open_in_new'
                }
            ]
            if (this.edit) {
                menu.splice(1, 0, {
                    event: {
                        name: 'delete',
                        id: this.convertedAttachment
                    },
                    display: this.$t('BUTTON_DELETE'),
                    materialIcon: 'delete'
                })
            }
            if ((this.type == 'single' || this.type == 'avatar') && this.edit) {
                menu.splice(1, 0, {
                    event: {
                        name: 'edit',
                        id: this.index
                    },
                    display: this.$t('CHANGE'),
                    materialIcon: 'edit'
                })
            }
            return menu
        }
    },
    methods: {
        download() {
            if (this.editing) {
                this.$emit('action', {
                    name: 'delete',
                    id: this.convertedAttachment
                })
                return
            }
            this.$Network.downloadFile(this.attachment)
        },
        previewAttachment() {
            this.selectedAttachment = this.convertedAttachment
        },
        actionEmitted(action) {
            switch (action.name) {
                case 'show':
                    this.previewAttachment()
                    break
                case 'edit':
                    this.$emit('action', {
                        name: 'edit'
                    })
                    break
                case 'delete':
                    this.$emit('action', {
                        name: 'delete',
                        id: action.id
                    })
                    break
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.attachment-wrap {
    transition: $ease;
    height: 5rem;
    width: 5rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    margin-right: 0.5rem;
    margin-bottom: 0.5rem;

    &.-dragging {
        pointer-events: none;
        opacity: 0.7;
    }
}
.attachment {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 0.2rem;
    border: solid 0.1rem $border-accent;
    box-sizing: border-box;

    &.-avatar {
        height: 6rem;
        width: 6rem;
        border-radius: 100%;
        overflow: visible;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        img {
            border-radius: 100%;
        }
    }

    &.-dragging {
        pointer-events: none;
    }
}
.attachment-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    margin-top: 0.5rem;
    font-family: $input-family;
    font-size: 0.8rem;
    padding: 0.15rem;
}
.attachment:hover .add-attachment {
    &:hover {
        transform: translateY(0.1rem);
    }
}
.attachment-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: $ease;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.attachment-file-icon {
    width: 100%;
    height: 100%;
    transition: $ease;

    &:hover {
        transform: translateY(0.1rem);
    }
}
</style>
